import React from "react";
import { ISubscriptionData } from "../../services/dashboard.services";
import NewSubscriptionItemLayout from "./NewSubscriptionItemLayout";

export default function NewSubscriptionData(props: IProps) {
  const { subscription_items } = props.subscriptionData;

  return (
    <React.Fragment>
      {subscription_items &&
        subscription_items.map((subItem, index) => {
          return (
            <NewSubscriptionItemLayout
              key={subItem.id}
              amount={subItem.amount}
              id={subItem.id}
              quantity={subItem.quantity}
              product={subItem.product}
              productID={subItem.product_id}
              itemQuantity={props.itemQuantity}
              handleSetItemQuantity={props.handleSetItemQuantity}
            ></NewSubscriptionItemLayout>
          );
        })}
    </React.Fragment>
  );
}

interface IProps {
  subscriptionData: ISubscriptionData;
  itemQuantity: { [key: string]: number };
  handleSetItemQuantity: (planId: string, quantity: number) => void;
}
